import React, { useState, useEffect } from "react";

const MapComponent = ({ data, status }) => {
  console.log("data::: ", data);
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    console.log("tidididiidi", data);
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyA0tm4EMf37E7HBXy9n8mvfFgILNDsSB-U&libraries=places`;
    script.async = true;
    script.onload = handleScriptLoad;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [data, status]);

  const handleScriptLoad = () => {
    if (Array.isArray(data) && data.length > 0) {
      // Initialize map centered on the first coordinate
      const map = new window.google.maps.Map(document.getElementById("map"), {
        center: {
          lat: data[0].lat || data[0].latitude,
          lng: data[0].lng || data[0].longitude,
        },
        zoom: 8,
      });

      console.log("map::: ", map);
      // Place a marker for each location
      data.forEach((location, index) => {
        new window.google.maps.Marker({
          position: {
            lat: parseFloat(location.lat || location.latitude),
            lng: parseFloat(location.lng || location.longitude),
          },
          map: map,
          title: `Location ${index + 1}`,
        });
      });
    } else {
      // Fallback if data is not an array
      const position = {
        lat: parseFloat(data.lat || data.latitude),
        lng: parseFloat(data.lng || data.longitude),
      };

      const map = new window.google.maps.Map(document.getElementById("map"), {
        center: position,
        zoom: 8,
      });

      new window.google.maps.Marker({
        position,
        map,
        title: "Company Location",
      });
    }
  };

  return <div id="map" style={{ width: "100%", height: "400px" }} />;
};

export default MapComponent;
